import gql from 'graphql-tag';

export default gql`
  query ($courseId: MongoID!, $studentId: MongoID!) {
    courseProgress(courseId: $courseId, studentId: $studentId) {
      courseId
      studentId
      totalContents
      completedContents
      progressPercent
    }
  }
`;
